let switcher = $('.lang-choice')

if (switcher.length > 0) {
    switcher.on('change', function() {
        let routeName = switcher.find(':selected').data('route_name'),
            routeParams = JSON.stringify(switcher.find(':selected').data('route_params'))
        curentLocal = switcher.find(':selected').data('actual_lang')

        let route = `${switcher
            .find(':selected')
            .data(
                'route',
            )}/?route_name=${routeName}&route_params=${routeParams}&lang=${curentLocal}`

        window.location.href = route
    })
}
